import {Directive, OnInit, inject} from '@angular/core';
import {AutorunComponent} from "@myshared/autorun.component";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter, Subscription} from "rxjs";

@Directive()
export abstract class WorkflowComponent extends AutorunComponent implements OnInit {
    public step: string = '';
    public applianceId: string = '';
    public initialized = false;

    protected route = inject(ActivatedRoute);
    protected router = inject(Router);
    
    private routeSubscription: Subscription;

    ngOnInit() {
        this.applianceId = this.route.snapshot.paramMap.get('aid') || this.route.snapshot.queryParamMap.get('aid') || '';
        this.updateStep();

        // Subscribe to router events to detect navigation
        this.routeSubscription = this.router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateStep();
        });
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    protected handleRoute(step: string) {
        this.step = step;
    }

    protected resetWorkflow() {
        if (!!this.applianceId) {
            window.location.replace('/subscriptions/'+this.applianceId);
        } else {
            window.location.replace('/');
        }
    }

    private updateStep() {
        const data = this.route.snapshot.firstChild?.data;
        let step = data?.['step'] ?? undefined;

        if (!step) {
            // Fallback: extract step from URL path
            const urlSegments = this.route.snapshot.firstChild?.url;
            step = urlSegments?.[urlSegments.length - 1]?.path;
        }

        this.handleRoute(step);
    }
}
